import { render, staticRenderFns } from "./PositionSettingsPageSidebar.vue?vue&type=template&id=6c5c8fb8&scoped=true&"
import script from "./PositionSettingsPageSidebar.vue?vue&type=script&lang=js&"
export * from "./PositionSettingsPageSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c8fb8",
  null
  
)

export default component.exports